import { Appointment } from '../types';

type AppointmentActionFields = Pick<
  Appointment,
  'cancelable' | 'reschedulable' | 'lateCancelFeeApplies'
>;

export const isLateCancelFeeApplicable = (
  appointment: Pick<Appointment, 'lateCancelFeeApplies'>
): boolean => appointment.lateCancelFeeApplies === true;

export const getAppointmentActionAvailability = (appointment: AppointmentActionFields) => {
  const lateCancelFeeApplies = isLateCancelFeeApplicable(appointment);
  const canCancelAppointment = appointment.cancelable;
  const canRescheduleAppointment = appointment.reschedulable && !lateCancelFeeApplies;

  return {
    lateCancelFeeApplies,
    canCancelAppointment,
    canRescheduleAppointment,
    canModifyAppointment: canCancelAppointment || canRescheduleAppointment
  };
};
